import {isNotNil} from 'ramda';

import {InvoiceV4ResponseBodyRead} from '@dms/api/finance';
import {Money} from '@dms/api/shared';
import {AccountingDocument} from '@dms/shared';

type AccountingDocumentWithExchangeRate = InvoiceV4ResponseBodyRead & {
  exchangeRateRatioDocumentSummary: {priceWithVat: Money};
};

export const getAccountingDocumentTotalPrice = (document: AccountingDocument) =>
  hasExchangeRateRatioDocumentSummary(document)
    ? document.exchangeRateRatioDocumentSummary.priceWithVat
    : (document?.totalPriceWithVat ?? null);

const hasExchangeRateRatioDocumentSummary = (
  document: AccountingDocument
): document is AccountingDocumentWithExchangeRate =>
  isNotNil(
    document && 'exchangeRateRatioDocumentSummary' in document
      ? document.exchangeRateRatioDocumentSummary?.priceWithVat
      : null
  );
